import React from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
export function Newsletter() {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success('Subscribed! Get ready for delicious updates.');
    (e.target as HTMLFormElement).reset();
  };
  return <section className="bg-foodMaroon py-20 border-y-4 border-foodMaroon relative overflow-hidden" data-id="element-191" data-mp="36p2xqd8ouzp0">
      {/* Decorative background shapes */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-192" data-mp="3ufyk2uudl2ov">
        <div className="absolute -top-24 -left-24 w-64 h-64 bg-foodTomato rounded-full mix-blend-multiply filter blur-3xl opacity-50" data-id="element-193" data-mp="382vht1gxj96"></div>
        <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-foodOrange rounded-full mix-blend-multiply filter blur-3xl opacity-50" data-id="element-194" data-mp="3qdboqjyhwzmx"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-195" data-mp="29xqzbxs70h8o">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-196" data-mp="2ez6ljt63wtsn">
          <h2 className="text-4xl md:text-5xl font-extrabold uppercase text-foodCream mb-4" data-id="element-197" data-mp="320j84ppmf29w">
            Never Miss a Bite
          </h2>
          <p className="text-xl text-foodCream/80 font-medium mb-8 max-w-2xl mx-auto" data-id="element-198" data-mp="2x0emymdrpjdc">
            Sign up for our newsletter to get first dibs on pop-up RSVPs,
            workshop tickets, and community news.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 justify-center max-w-2xl mx-auto" data-id="element-199" data-mp="361uos5qiod5y">
            <input type="email" required placeholder="Enter your email address" className="flex-grow bg-foodCream border-4 border-foodCream text-foodMaroon px-6 py-4 font-bold focus:outline-none focus:border-foodOrange text-lg" data-id="element-200" data-mp="3freb5ldfup5k" />
            <button type="submit" className="bg-foodOrange text-white font-bold text-lg px-8 py-4 border-4 border-foodOrange hover:bg-foodTomato hover:border-foodTomato transition-colors whitespace-nowrap" data-id="element-201" data-mp="ofqsd0d4pdn">
              Subscribe
            </button>
          </form>
        </motion.div>
      </div>
    </section>;
}